import React from 'react';

export const CitationCard = ({ citation }) => {
  return (
    <div 
      data-testid="citation-card"
      className="border-l-4 border-primary-500 bg-surface p-3 rounded text-sm space-y-1 hover:bg-surfaceHighlight transition-colors duration-200"
    >
      <div className="flex items-center justify-between">
        <span className="font-semibold text-primary-900">{citation.source_name}</span>
        <span className="text-xs text-muted-foreground uppercase tracking-wide">{citation.source_type}</span>
      </div>
      {citation.excerpt && (
        <p className="text-muted-foreground italic text-xs line-clamp-2">
          "{citation.excerpt}"
        </p>
      )}
      {citation.source_url && (
        <a
          data-testid="citation-link"
          href={citation.source_url}
          target="_blank"
          rel="noopener noreferrer"
          className="text-primary-500 hover:text-primary-900 text-xs font-medium inline-flex items-center gap-1 hover:underline"
        >
          Zobacz źródło
          <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
          </svg>
        </a>
      )}
    </div>
  );
};
